// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2MSay","selected":"Chip_selected__2rzED"};